
/**
 * 계정 상태
 */
export type UserPageResponseContentItemStatus = typeof UserPageResponseContentItemStatus[keyof typeof UserPageResponseContentItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPageResponseContentItemStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
  DELETED: 'DELETED',
} as const;
